import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  public translationsSubject: BehaviorSubject<any>;

  public userLocaleSubject: BehaviorSubject<string>;
  public userPrimaryLangSubject: BehaviorSubject<string>;
  public userSecondaryLangSubject: BehaviorSubject<string>;
  public directionSubject: BehaviorSubject<string>;

  public defaultLocale: string = "En";
  public defaultDirection: string = "ltr";
  public defaultPrimaryLang: string = "Ar";//Ar for arabic, En for english
  public defaultSecondaryLang: string = "En";//Ar for arabic, En for english

  public localeStorageKey: string = "locale";
  public directionStorageKey: string = "direction";

  constructor() {
    //default values
    this.translationsSubject = new BehaviorSubject<any>({});

    this.userLocaleSubject = new BehaviorSubject<string>(localStorage.getItem(this.localeStorageKey));
    if (!this.userLocaleSubject.value) {
      this.userLocaleSubject = new BehaviorSubject<string>(this.defaultLocale);
      localStorage.setItem(this.localeStorageKey, this.defaultLocale);
    }
    this.userPrimaryLangSubject = new BehaviorSubject<string>(this.defaultPrimaryLang);
    this.userSecondaryLangSubject = new BehaviorSubject<string>(this.defaultSecondaryLang);
    this.setPrimaryLang();
    this.setSecondaryLang();

    this.directionSubject = new BehaviorSubject<string>(localStorage.getItem(this.directionStorageKey));
    if (!this.directionSubject.value) {
      this.directionSubject = new BehaviorSubject<string>(this.defaultDirection);
      localStorage.setItem(this.directionStorageKey, this.defaultDirection);
    }
  }

  public getPrimaryLang(): string {
    return this.userPrimaryLangSubject.value;
  }

  public setPrimaryLang() {
    this.userPrimaryLangSubject.next(this.getLocale() === "ar_jo" ? "Ar" : "En");
  }

  public getSecondaryLang(): string {
    return this.userSecondaryLangSubject.value;
  }

  public setSecondaryLang() {
    this.userSecondaryLangSubject.next(this.getLocale() === "ar_jo" ? "En" : "Ar");
  }

  public getLocale(): string {
    return this.userLocaleSubject.value;
  }

  public setLocale(value: any) {
    this.userLocaleSubject.next(value);
    this.setPrimaryLang();
    this.setSecondaryLang();
    localStorage.setItem(this.localeStorageKey, value);
  }

  public resetLocale() {
    this.userLocaleSubject.next(this.defaultLocale);
    this.setPrimaryLang();
    this.setSecondaryLang();
    localStorage.setItem(this.localeStorageKey, this.defaultLocale);
  }

  public getDirection(): string {
    return this.directionSubject.value;
  }

  public setDirection(direction: string) {
    this.directionSubject.next(direction);
    localStorage.setItem(this.directionStorageKey, direction);
  }

  public resetDirection() {
    this.directionSubject.next(this.defaultDirection);
    localStorage.setItem(this.directionStorageKey, this.defaultDirection);
  }

  public getTranslations(): any {
    return this.translationsSubject.value;
  }

  public setTranslations(translations: any) {
    this.translationsSubject.next(translations);
  }

}